import {NgxFilesizeModule} from 'ngx-filesize';
import { CommonModule } from '@angular/common';
import { OrderModule } from 'ngx-order-pipe';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { RouterModule } from '@angular/router';
import { RenameComponent } from './components/rename/rename.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { PrimengModule } from '../primeng/primeng.module';
import { NameDescFormComponent } from './components/name-desc-form/name-desc-form.component';
import { PersonInfoFormComponent } from './components/person-info-form/person-info-form.component';
import { HtmlContentFormComponent } from './components/html-content-form/html-content-form.component';
import { FormsService } from '../services/common/forms.service';
import { EditorModule } from '@tinymce/tinymce-angular';
import { PersonRegOnlineFormComponent } from './components/person-reg-online-form/person-reg-online-form.component';
import { StructureGraphPieComponent } from './components/structure-graph-pie/structure-graph-pie.component';
import { StructureTableComponent } from './components/structure-table/structure-table.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { StructureGraphBarComponent } from './components/structure-graph-bar/structure-graph-bar.component';
import { TableSortDirective } from './directives/sort.directive';
import { PersonPreliminaryFormDialogComponent } from './components/person-preliminary-form-dialog/person-preliminary-form-dialog.component';
import { TimelineGraphLineComponent } from './components/timeline-graph-line/timeline-graph-line.component';
import { CurrentConferenceNavbarComponent } from './components/current-conference-navbar/current-conference-navbar.component';
import { StructureTablePrimeComponent } from './components/structure-table-prime/structure-table-prime.component';
import { PersonInfoViewComponent } from './components/person-info-view/person-info-view.component';
import { PersonConferenceVisitViewComponent } from './components/person-conference-visit-view/person-conference-visit-view.component';
import { PersonConferencePaymentViewComponent } from './components/person-conference-payment-view/person-conference-payment-view.component';
import { ClipboardModule } from 'ngx-clipboard';
import { PersonConferenceVisitDialogComponent } from './components/person-conference-visit-dialog/person-conference-visit-dialog.component';
import { RegPersonVisitFormComponent } from './components/reg-person-visit-form/reg-person-visit-form.component';
import { PersonConferencePaymentDialogComponent } from './components/person-conference-payment-dialog/person-conference-payment-dialog.component';
import { RegPersonPaymentFormComponent } from './components/reg-person-payment-form/reg-person-payment-form.component';
import { PersonConferenceCertificateViewComponent } from './components/person-conference-certificate-view/person-conference-certificate-view.component';
import { IacmacFormDialogComponent } from './components/iacmac-form-dialog/iacmac-form-dialog.component';
import { HtmlContentDialogComponent } from './components/abstract-dialog-form/html-content-dialog/html-content-dialog.component';
import { InputContentDialogComponent } from './components/abstract-dialog-form/input-content-dialog/input-content-dialog.component';
import { FormControlContentDialogComponent } from './components/abstract-dialog-form/form-control-content-dialog/form-control-content-dialog.component';
import { SafeHtmlPipe } from './directives/safe-html.pipe';
import { PersonConferenceAbstractViewComponent } from './components/person-conference-abstract-view/person-conference-abstract-view.component';
import { PersonAbstractEditDialogComponent } from './components/person-abstract-edit-dialog/person-abstract-edit-dialog.component';
import { PersonConferenceChangeBulkStatusDialogComponent } from './components/person-conference-change-bulk-status-dialog/person-conference-change-bulk-status-dialog.component';
import { WrapperPublicComponent } from './components/wrapper-public/wrapper-public.component';
import { RemoveHtmlPipe } from './directives/remove-html.pipe';
import { SelectConferenceDialogComponent } from './components/select-conference-dialog/select-conference-dialog.component';
import { FileUploadModule } from 'primeng/fileupload';
import { UploadPosterPdfComponent } from './components/upload-poster-pdf/upload-poster-pdf.component';
import { VideoLinkAbstractComponent } from './components/video-link-abstract/video-link-abstract.component';
import { StripHtmlPipe } from './directives/strip-html.pipe';
import { TruncatePipe } from './directives/truncate.pipe';
import { StructureGraphPieSimpleComponent } from './components/structure-graph-pie-simple/structure-graph-pie-simple.component';
import { StructureGraphBarSimpleComponent } from './components/structure-graph-bar-simple/structure-graph-bar-simple.component';
import { NgModule } from '@angular/core';
import { HeaderComponent } from '../components/header/header.component';
import { ConfStatRegisteredTableComponent } from './components/conf-stat-registered-table/conf-stat-registered-table.component';
import { ConfStatVisitTableComponent } from './components/conf-stat-visit-table/conf-stat-visit-table.component';
import { ConfStatVisitDaysTableComponent } from './components/conf-stat-visit-days-table/conf-stat-visit-days-table.component';
import { ConfStatTabsComponent } from './components/conf-stat-tabs/conf-stat-tabs.component';
import { SelectGeoConferenceDialogComponent } from './components/select-geo-conference-dialog/select-geo-conference-dialog.component';

// import { }

@NgModule({
  declarations: [
    SelectGeoConferenceDialogComponent,
    HeaderComponent,
    RenameComponent,
    NameDescFormComponent,
    PersonInfoFormComponent,
    HtmlContentFormComponent,
    PersonRegOnlineFormComponent,
    StructureGraphPieComponent,
    StructureTableComponent,
    StructureGraphBarComponent,
    SafeHtmlPipe,
    RemoveHtmlPipe,
    StripHtmlPipe,
    TruncatePipe,
    TableSortDirective,
    PersonPreliminaryFormDialogComponent,
    TimelineGraphLineComponent,
    CurrentConferenceNavbarComponent,
    StructureTablePrimeComponent,
    PersonInfoViewComponent,
    PersonConferenceVisitViewComponent,
    PersonConferencePaymentViewComponent,
    PersonConferenceVisitDialogComponent,
    RegPersonVisitFormComponent,
    RegPersonPaymentFormComponent,
    PersonConferencePaymentDialogComponent,
    PersonConferenceCertificateViewComponent,
    IacmacFormDialogComponent,
    HtmlContentDialogComponent,
    InputContentDialogComponent,
    FormControlContentDialogComponent,
    PersonConferenceAbstractViewComponent,
    PersonAbstractEditDialogComponent,
    PersonConferenceChangeBulkStatusDialogComponent,
    SelectConferenceDialogComponent,
    UploadPosterPdfComponent,
    VideoLinkAbstractComponent,
    StructureGraphPieSimpleComponent,
    StructureGraphBarSimpleComponent,
    ConfStatRegisteredTableComponent,
    ConfStatVisitTableComponent,
    ConfStatVisitDaysTableComponent,
    ConfStatTabsComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgApexchartsModule,
    FilterPipeModule,
    NgxFilesizeModule,
    OrderModule,
    RouterModule,
    PrimengModule,
    EditorModule,
    ClipboardModule,
    FileUploadModule,
  ],
  exports: [
    PrimengModule,
    FilterPipeModule,
    OrderModule,
    NgxFilesizeModule,
    ReactiveFormsModule,
    FormsModule,
    FileUploadModule,
    RenameComponent,
    HeaderComponent,
    NameDescFormComponent,
    HtmlContentFormComponent,
    PersonRegOnlineFormComponent,
    EditorModule,
    ClipboardModule,
    StructureGraphPieComponent,
    StructureGraphBarComponent,
    StructureTableComponent,
    StructureTablePrimeComponent,
    TimelineGraphLineComponent,
    TableSortDirective,
    SafeHtmlPipe,
    RemoveHtmlPipe,
    StripHtmlPipe,
    TruncatePipe,
    CurrentConferenceNavbarComponent,
    PersonInfoViewComponent,
    PersonConferenceVisitViewComponent,
    PersonConferencePaymentViewComponent,
    RegPersonVisitFormComponent,
    RegPersonPaymentFormComponent,
    PersonConferenceCertificateViewComponent,
    IacmacFormDialogComponent,
    PersonConferenceAbstractViewComponent,
    UploadPosterPdfComponent,
    VideoLinkAbstractComponent,
    StructureGraphPieSimpleComponent,
    StructureGraphBarSimpleComponent,
    ConfStatRegisteredTableComponent,
    ConfStatVisitTableComponent,
    ConfStatVisitDaysTableComponent,
    ConfStatTabsComponent
  ],
  providers: [
    FormsService
  ],
})
export class SharedCompilationModule { }
